module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "big-title"
  }, [_vm._v("vux!vue")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h3', [_vm._v("介绍")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', [_vm._v("虽然路径不长，但是看着相当不和谐，为了简化这个操作vux提供了更简洁的写法：")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('h3', [_vm._v("实现方式")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', [_vm._v("上面的代码强行处理后是这样的：")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', [_vm._v("原理就是这么简单（但是处理时还是遇到一些问题），为了方便使用，编写了常用的一些插件。")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('h3', [_vm._v("实际使用场景")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', [_vm._v("对于公用组件而言，完全可以实现构建时进行组件瘦身，只保留使用到的代码。")]), _vm._v(" "), _c('p', [_vm._v("当然如果你愿意，你完全可以自己实现一门语言。")]), _vm._v(" "), _c('h2', [_vm._v("安装")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('h2', [_vm._v("使用")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n  更新配置后需要重启npm run dev命令\n")]), _vm._v(" "), _c('h3', [_vm._v("Options")]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('h3', [_vm._v("Plugins")]), _vm._v(" "), _c('p', [_vm._v("插件为一个数组列表，根据需要可以添加你需要的插件，插件名为必须，有些组件不需要额外配置选项。")]), _vm._v(" "), _c('p', [_vm._v("公用参数为:")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('h4', [_vm._v("script-parser")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("script代码替换处理")])]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('h4', [_vm._v("style-parser")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("style代码替换处理")])]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('h4', [_vm._v("template-parser")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("template代码替换处理")])]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("适用于对"), _c('code', [_vm._v("<template></template>")]), _vm._v("模板代码做自定义处理"), _c('br'), _vm._v("\n适用于某些更改不频繁但非服务端配置的文字，可能调用多次，也可能手动更改或者批量替换相对麻烦")]), _vm._v(" "), _c('p', [_vm._v("同样你也可以用来从接口获取最新配置替换特定的占位字符")]), _vm._v(" "), _c('p', [_vm._v("当然也适用于在源码中对"), _c('code', [_vm._v("pm")]), _vm._v("进行吐槽(千万要记得production环境要有配置，否则可能会上新闻。)")])]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('p', [_vm._v("插件配置：")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('h4', [_vm._v("js-parser")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("项目里js文件处理，在babel-loader前进行处理")])]), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('h4', [_vm._v("template-feature-switch")]), _vm._v(" "), _c('p', [_vm._v("实现根据变量切换template代码")]), _vm._v(" "), _c('p', [_vm._v("参数：")]), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('h4', [_vm._v("vux-ui")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n  vux组件的配套工具，如果没有使用vux, 不需要添加。\n")]), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('p', [_vm._v("该插件做了以下处理：")]), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('p', [_vm._v("那么你就可以很方便地引入组件了：")]), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('h4', [_vm._v("i18n")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n请使用正确的 yml 格式。冒号和值之间是有一个空格的，错误的格式将无法生效。\n")]), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('h4', [_vm._v("less-theme")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n注意，path所在文件必须是简单的less变量对，不能import其他文件或者引入变量。\n")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("less 变量设置和替换")])]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("适用于全局变量替换,  方便切换主题"), _c('br'), _vm._v("\n这意味着，你不再需要为每个页面引入全局的less文件了，你只需要设置lang为less就可以直接使用变量了")])]), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', [_vm._v("插件配置：")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('h4', [_vm._v("duplicate-style")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("css 重复代码清除")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n  建议使用vux组件的用户使用，因为vux直接引用less，最终构建的css文件确实会有冗余。\n")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("在webpack 构建完成后对生成的css文件使用cssnano进行重复样式清除。建议只在production环境下开启，因为dev环境没有必要。")])]), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('h4', [_vm._v("html-build-callback")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("html文件处理事件回调")])]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("适用于在写入html(一般为index.html)文件前进行内容修改，比如替换特定内容"), _c('br'), _vm._v("\n比如写入js配置变量，改变cdn域名，将manifest文件直接写入html以减少请求等")])]), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _c('h4', [_vm._v("build-done-callback")]), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("构建完成事件回调"), _c('br'), _vm._v("\n本质上是在webpack plugin的 done 事件后触发")])]), _vm._v(" "), _vm._m(50), _vm._v(" "), _c('h3', [_vm._v("使用案例")]), _vm._v(" "), _c('h4', [_vm._v("统一引入less(sass)变量")]), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('h4', [_vm._v("减少重复代码")]), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('h4', [_vm._v("实现import语法转换")]), _vm._v(" "), _c('p', [_vm._v("vux是没有main入口文件的，因此需要把import语句转换成单个组件引入。但是因为对语法树分析比较烦，能用正则替换的当然就是用正则替换，简单粗暴实用。具体可以看源码。")]), _vm._v(" "), _c('h4', [_vm._v("开源组件多语言支持")]), _vm._v(" "), _c('p', [_vm._v("如果以js方式分发，一般默认一个语言，用户可以加上另外的语言包，但是代码里必不可少存在相应的转换函数，对于只需要单语言的人来是个浪费和繁琐。要么所有一起打包，这个也极浪费。要么一个一个打包，这样又失去了动态多语言支持。")]), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('h3', [_vm._v("Bug 反馈 && 功能建议")]), _vm._v(" "), _vm._m(60), _vm._v(" "), _c('h3', [_vm._v("Todo")]), _vm._v(" "), _vm._m(61)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vux-loader"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/v/vux-loader.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vux-loader"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/dm/vux-loader.svg?style=flat-square",
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("vux-loader")]), _vm._v("工具的作用是对"), _c('code', [_vm._v(".vue")]), _vm._v("代码进行预处理，不限于 vux 组件库。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("它是针对"), _c('code', [_vm._v("webpack+vue-loader")]), _vm._v("项目的工程化工具，简化了webpack插件和loader的使用和编写，支持在vue-loader处理之前进行预处理，同时内置对vux组件专用的配置和优化插件。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("当然除了.vue文件外，你还可以对js文件进行预处理。说好的处理.vue文件，为什么连"), _c('code', [_vm._v("js")]), _vm._v("文件也不放过呢？因为只有处理js才能实现理想工程化。举个例子，如果用户需要在"), _c('code', [_vm._v("main.js")]), _vm._v("中调用vux的plugin，他需要这样做：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" AlertPlugin "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/plugins/Alert'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" ToastPlugin "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/plugins/Toast'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { AlertPlugin, ToastPlugin } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("这个操作即是通过"), _c('code', [_vm._v("js-parser")]), _vm._v("插件解析main.js里的"), _c('code', [_vm._v("import")]), _vm._v("语法来实现的，最终进入babel的代码和上面单独引入一致。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("这个工具也许会帮你进一步打开"), _c('code', [_vm._v("Vue")]), _vm._v("项目工程化的思路。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n  作为通用工具，即使你没有使用Vux，依然可以使用它来进行各种代码处理。\n  "), _c('br'), _vm._v("\n  目前支持 vue-loader@>9.x, 低版本没有具体测试。\n  "), _c('br'), _vm._v("\n  `vux!vue`的loader写法只兼容webpack@1.x，为了兼容webpack@2.x，处理后的loader配置是`vux-loader!vue-loader`\n")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("说明一下"), _c('code', [_vm._v("vux-loader")]), _vm._v("是如何和"), _c('code', [_vm._v("vue-loader")]), _c('del', [_vm._v("搞基")]), _vm._v("配合的，vue-loader的issue里不少同学遇到预处理.vue的问题。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如果你看过"), _c('code', [_vm._v("webpack")]), _vm._v("loader的介绍，理论上说如果需要自己手动先处理代码再传入"), _c('code', [_vm._v("vue-loader")]), _vm._v(",你只需要这样对loader做配置: "), _c('code', [_vm._v("vue-loader!my-loader")]), _vm._v("。但是如果你试过，就知道这个目前行不通。"), _c('code', [_vm._v("vue-loader")]), _vm._v("不会接收上一个loader的source进行处理，因为.vue文件的特殊性，它直接生成了loader string进入下一个处理，处理后的结果大概是这样的：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* styles */")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!vue-style-loader!css-loader!vue-loader/lib/style-rewriter?id=data-v-20d7ba9a!vue-loader/lib/selector?type=styles&index=0!./index.vue\"")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* script */")]), _vm._v("\n__vue_exports__ = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!babel-loader!vue-loader/lib/selector?type=script&index=0!./index.vue\"")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* template */")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("var")]), _vm._v(" __vue_template__ = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!vue-loader/lib/template-compiler?id=data-v-20d7ba9a!vue-loader/lib/selector?type=template&index=0!./index.vue\"")]), _vm._v(")\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("那么vue-loader提供了自定义loader string的选项，直接配置可否呢，"), _c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue-loader/issues/531"
    }
  }, [_vm._v("#531")]), _vm._v("，直接配置会破坏原来的loader参数，导致不能Live reload。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("那么最终能想到的就是直接修改"), _c('code', [_vm._v("vue-loader")]), _vm._v("生成的代码，这样既不会影响"), _c('code', [_vm._v("vue-loader")]), _vm._v("原来的逻辑，也能自由控制。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("最终实现方式是前置"), _c('code', [_vm._v("vux-loader")]), _vm._v("即："), _c('code', [_vm._v("vux-loader!vue-loader")]), _vm._v("，vux-loader将vue-loader生成的代码二次处理，分割loader string并(强行)插入vux的 template-loader, style-loader, script-loader，那么你就能理解vux-loader的配置方式了，在3大基本loader里获取到vux-loader的插件配置列表逐个做处理就行了。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* styles */")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!vue-style-loader!css-loader!vue-loader/lib/style-rewriter?id=data-v-20d7ba9a!./../../../../vux-loader/src/style-loader.js!vue-loader/lib/selector?type=styles&index=0!./index.vue\"")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* script */")]), _vm._v("\n__vue_exports__ = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!babel-loader!vue-loader/lib/selector?type=script&index=0!./../../../../vux-loader/src/script-loader.js!./index.vue\"")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("/* template */")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("var")]), _vm._v(" __vue_template__ = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"!!vue-loader/lib/template-compiler?id=data-v-20d7ba9a!./../../../../vux-loader/src/template-loader.js!vue-loader/lib/selector?type=template&index=0!./index.vue\"")]), _vm._v(")\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("至于"), _c('code', [_vm._v("js-parser")]), _vm._v("就只是在"), _c('code', [_vm._v("babel-loader")]), _vm._v("前加上了"), _c('code', [_vm._v("vux-loader")]), _vm._v("的"), _c('code', [_vm._v("js-loader")]), _vm._v("。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("而所有的loader, plugins设置都是在"), _c('code', [_vm._v("vux-loader")]), _vm._v("的"), _c('code', [_vm._v("merge")]), _vm._v("方法里来完成。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("我们可以使用"), _c('code', [_vm._v("vux-loader")]), _vm._v("做一些很有意思的事。"), _c('br'), _vm._v("\n比如 "), _c('a', {
    attrs: {
      "href": "https://github.com/vuejs/vue-loader/issues/542"
    }
  }, [_vm._v("#542")]), _vm._v(" 提到的根据当前feature为判断要输出哪一部分代码，现在已经直接支持，请看 "), _c('code', [_vm._v("template-feature-switch")]), _vm._v("部分。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("npm install vux-loader --save-dev\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("为了减少使用成本，只需要调用"), _c('code', [_vm._v("merge")]), _vm._v("方法对原来"), _c('code', [_vm._v("webpack")]), _vm._v("配置进行操作：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" webpackConfig = {} "), _c('span', {
    staticClass: "hljs-comment"
  }, [_vm._v("// 原来的webpack配置")]), _vm._v("\n\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" vuxLoader = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-loader'")]), _vm._v(")\n\n"), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("module")]), _vm._v(".exports = vuxLoader.merge(webpackConfig, {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("options")]), _vm._v(": {},\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("plugins")]), _vm._v(": [{\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux-ui'")]), _vm._v("\n  }]\n})\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("env")]), _vm._v(" 非必选，定义当前环境变量，只在vux-loader里使用，用来判断哪些插件需要被执行(如果plugin有定义envs的话)，目的是实现一份配置多个环境使用。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("name")]), _vm._v(" "), _c('code', [_vm._v("必须")]), _vm._v("，插件名字")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("envs")]), _vm._v(" "), _c('code', [_vm._v("非必须")]), _vm._v("，数组，当前插件在哪些环境变量里执行，不定义则默认执行")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("下面的插件配置代码将省略 "), _c('code', [_vm._v("plugins:[]")]), _vm._v("的书写。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'script-parser'")]), _vm._v(",\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("source")]), _vm._v(") ")]), _vm._v("{\n   "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" source.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'VARIABLE'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'v2'")]), _vm._v(")\n }\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'style-parser'")]), _vm._v(",\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("source")]), _vm._v(") ")]), _vm._v("{\n   "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" source.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'black'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'white'")]), _vm._v(")\n }\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("name 插件名字， "), _c('code', [_vm._v("template-parser")])]), _vm._v(" "), _c('li', [_vm._v("replaceList 非必须，正则匹配列表，将直接调用 "), _c('code', [_vm._v("replace")]), _vm._v(" 方法进行替换")]), _vm._v(" "), _c('li', [_vm._v("fn 非必须，相比params更灵活的方法，可以对字符串进行处理后返回")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[\n  name: "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"template-parser\"")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("replaceList")]), _vm._v(": [{\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/DeathToPM/g")]), _vm._v(",\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("replaceString")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'微博-随时随地发现新鲜事'")]), _vm._v("\n  }, {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/呵呵我们压根没有底线/g")]), _vm._v(",\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("replaceString")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'我是有底线的'")]), _vm._v("\n  }],\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("templateSource")]), _vm._v(") ")]), _vm._v("{\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" templateSource.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'智障'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'机智'")]), _vm._v(")\n  }\n]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("[{\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'js-parser'")]), _vm._v(",\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("source")]), _vm._v(") ")]), _vm._v("{\n   "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" source.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'black'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'white'")]), _vm._v(")\n }\n}]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("features")]), _vm._v("，变量列表，值只能为true或者false")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'template-feature-switch'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("features")]), _vm._v(": {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("feature1")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(",\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("feature2")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v("\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("on")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("feature")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"feature1\"")]), _vm._v(">")]), _vm._v("\n      AWESOME FEATURE 1 is ON\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("on")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("off")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("feature")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"feature1\"")]), _vm._v(">")]), _vm._v("\n      AWESOME FEATURE 1 is OFF\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("off")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("template")]), _vm._v(">")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("那么当 feature1 为 true时，将输出 "), _c('code', [_vm._v("AWESOME FEATURE 1 is ON")]), _vm._v(", 反之则输出 "), _c('code', [_vm._v("AWESOME FEATURE 1 is OFF")]), _vm._v("。注意"), _c('code', [_vm._v("on")]), _vm._v("标签内不限定内容，可以为任何标签代码块，但"), _c('code', [_vm._v("避免在on off 里面再嵌套 on off")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如果配合"), _c('code', [_vm._v("vux")]), _vm._v("使用，需要手动启用。默认不需要设置选项。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("配置"), _c('code', [_vm._v("babel")]), _vm._v("编译 vux 的js源码")]), _vm._v(" "), _c('li', [_vm._v("修改vue-loader为 "), _c('code', [_vm._v("vux-loader!vue-loader")])]), _vm._v(" "), _c('li', [_c('code', [_vm._v("import")]), _vm._v("组件调用解析为单组件引入")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  name: 'vux-ui'\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("// 0.x\nimport Group from 'vux/src/components/group'\nimport Cell from 'vux/src/components/cell'\n\n// 2.x\nimport { Group, Cell } from 'vux'\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("on-show:")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("  en:")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("emits")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("when")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("popup")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("shows")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("  zh-CN:")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("弹窗显示时触发")]), _vm._v("\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_c('p', [_vm._v("如果你只是调用中文语言的vux组件，那么你不需要做任何配置。")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("如果你需要调用英文语言的vux组件，需要配置语言")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'i18n'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("vuxStaticReplace")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("true")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("vuxLocale")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'en'")]), _vm._v("\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    attrs: {
      "start": "3"
    }
  }, [_c('li', [_vm._v("如果你想和demo站点一样可以写"), _c('code', [_vm._v("i18n")]), _vm._v("block，并且需要动态切换语言，那么需要配置插件抽取i18n的内容，并设置非静态替换")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'i18n'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("vuxStaticReplace")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("staticReplace")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("extractToFiles")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src/locales/components.yml'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("localeList")]), _vm._v(": ["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'en'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'zh-CN'")]), _vm._v("]\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("然后你就可以引用"), _c('code', [_vm._v("vuex-i18n")]), _vm._v("插件实现多语言切换了。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("参考 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/254574ef30a8c4d341feb7d2ff8245792657bda2/src/main.js#L84-L96"
    }
  }, [_vm._v("main.js")]), _vm._v(" 及 "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vuex-i18n"
    }
  }, [_vm._v("vuex-i18n 文档")]), _vm._v("(仅当参考，你也可以使用其他i18n插件)。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("<style lang=\"less\">\n.info {\n color: @font-size;\n}\n</style>\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'less-theme'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'src/styles/theme.less'")]), _vm._v("\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'duplicate-style'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("events")]), _vm._v(": {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("done")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }), _vm._v(") ")]), _vm._v("{\n      "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'done!'")]), _vm._v(")\n    }\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'html-build-callback'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("events")]), _vm._v(": {\n   "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'after-html-processing'")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("data, cb")]), _vm._v(") ")]), _vm._v("{\n      data.html += "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'magic footer'")]), _vm._v("\n      cb("), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("null")]), _vm._v(", data)\n   }\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("可用事件请参考 "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/html-webpack-plugin"
    }
  }, [_vm._v("html-webpack-plugin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'build-done-callback'")]), _vm._v(",\n "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }), _vm._v(") ")]), _vm._v("{\n   "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("console")]), _vm._v(".log("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'done!'")]), _vm._v(")\n }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("如果你翻看"), _c('code', [_vm._v("vue-loader")]), _vm._v("的issue, 就会发现不少同学在说，为什么sass, less 变量不能全局使用，需要在每个.vue组件里引入，这个很重复，有没有办法解决。目前除了在webpack里定义路径"), _c('code', [_vm._v("alias")]), _vm._v("外没有其他方法。但是有了"), _c('code', [_vm._v("vux-loader")]), _vm._v("，你可以用"), _c('code', [_vm._v("style-parser")]), _vm._v("在每个"), _c('code', [_vm._v(".vue")]), _vm._v("文件的style前面加上变量的引入了，只要一句代码。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  name: 'style-parser',\n  fn: function (source) {\n    return \"@import '../styles/variable.less'\\n\" + source // 你可以根据this.resourcePath 来确定是否要引入以及引入的相对路径\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('code', [_vm._v("vux")]), _vm._v("的组件有几十个，同样demo也有几十个，因为webpack并不支持require变量，那么在main里中实现每个组件异步加载都需要这样：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" routes = [\n  {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("path")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'/component/actionsheet'")]), _vm._v(",\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("component")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("resolve")]), _vm._v(") ")]), _vm._v("{\n      "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("require")]), _vm._v("(["), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'./demos/Actionsheet'")]), _vm._v("], resove)\n    }\n  }\n]\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("作为懒人，写几十次这样的代码是一件比较烦人的事，作为热爱地球的人，这样也很不环保，但是有了"), _c('code', [_vm._v("vux-loader")]), _vm._v(", 我们可以这样：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("const")]), _vm._v(" routes = []\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("然后在"), _c('code', [_vm._v("js-parser")]), _vm._v("里获取列表数组直接替换， 并且可以调用webpack的"), _c('code', [_vm._v("this.addDependency")]), _vm._v("添加依赖实现修改列表时自动"), _c('code', [_vm._v("reload")]), _vm._v("。从此添加删除组件只要加上或者删除名字就可以了，真是"), _c('del', [_vm._v("懒")]), _vm._v("机智。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'js-parser'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("test")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-regexp"
  }, [_vm._v("/main\\.js/")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("fn")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("function")]), _vm._v(" ("), _c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("source")]), _vm._v(") ")]), _vm._v("{\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".addDependency(demoPath)\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("let")]), _vm._v(" list = fs.readFileSync(demoPath, "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'utf-8'")]), _vm._v(")\n    list = "), _c('span', {
    staticClass: "hljs-built_in"
  }, [_vm._v("JSON")]), _vm._v(".parse(list)\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("let")]), _vm._v(" str = []\n    list.forEach("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("one")]), _vm._v(" =>")]), _vm._v(" {\n      str.push("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("`{\npath: '/component/"), _c('span', {
    staticClass: "hljs-subst"
  }, [_vm._v("${toDash(one)}")]), _vm._v("',\ncomponent: function (resolve) {\nrequire(['./demos/"), _c('span', {
    staticClass: "hljs-subst"
  }, [_vm._v("${one}")]), _vm._v(".vue'], resolve)\n}\n}`")]), _vm._v(")\n    })\n\n    str = "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("`["), _c('span', {
    staticClass: "hljs-subst"
  }, [_vm._v("${str.join("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("',\\n'")]), _vm._v(")}")]), _vm._v("]`")]), _vm._v("\n    source = source.replace("), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'const routes = []'")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'const routes = '")]), _vm._v(" + str)\n    "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" source\n  }\n}\n")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("于是"), _c('code', [_vm._v("vux")]), _vm._v("在"), _c('code', [_vm._v("vux-loader")]), _vm._v("的支持下实现了"), _c('code', [_vm._v("使用时构建")]), _vm._v("，无论是静态输出和动态支持。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("请到"), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux-loader/issues"
    }
  }, [_vm._v("https://github.com/airyland/vux-loader/issues")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("[ ] 支持各个插件的异步返回形式")]), _vm._v(" "), _c('li', [_vm._v("[ ] 在插件中提供webpack的 this 参数")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3b360192", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-3b360192"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vux-loader-5.vue
// module id = 2160
// module chunks = 196